import axiosConfig from "./axiosConfig";

interface HhDataTempCommitResponse {
  success: boolean;
  message?: string;
}

const postHhDataTempCommit = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataTempCommitResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/commit`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataTempCommit;
